import { ref, nextTick } from '@nuxtjs/composition-api';
import { useUiHelpers } from '~/composables';

export const useCategoryNavigation = () => {
  const uiHelpers = useUiHelpers();
  const productContainerElement = ref<HTMLElement | null>(null);

  const goToPage = (page: number) => {
    uiHelpers.changePage(page, false);
    nextTick(() => {
      productContainerElement.value?.scrollIntoView({ block: 'start' });
      window.scrollBy(0, -200);
    });
  };

  return {
    productContainerElement,
    goToPage,
  };
};
